import React from "react";
import { styled, TextField as MTextField } from "@mui/material";

const StyledTextField = styled(MTextField)`
  & .MuiFormLabel-root {
    font-family: ${({ theme }) => theme.fonts.family.default};
    font-size: ${({ theme }) => theme.fonts.size.inputs.title};
    font-weight: 800;
    color: ${({ theme }) => theme.colors.gray["300"]};
  }
  & .MuiFormLabel-root.Mui-focused {
    color: ${({ theme }) => theme.colors.gray["800"]};
  }
  & .MuiInputBase-root {
    font-family: ${({ theme }) => theme.fonts.family.default};
    font-size: ${({ theme }) => theme.fonts.size.inputs.content};
    font-weight: 400;
  }
  & .MuiFilledInput-underline:after {
    border-bottom: 2px solid ${({ theme }) => theme.colors.gray["800"]};
  }
  & .Mui-error:after {
    border-bottom: 2px solid ${({ theme }) => theme.colors.error};
  }
  & .MuiFormLabel-root.Mui-error {
    color: ${({ theme }) => theme.colors.error};
  }
  & .MuiFormHelperText-root.Mui-error {
    color: ${({ theme }) => theme.colors.error};
  }
`;

const TextField = ({
  shrinked = true,
  fullWidth = true,
  InputLabelProps,
  ...other
}) => (
  <StyledTextField
    InputLabelProps={{
      shrink: shrinked,
      ...InputLabelProps,
    }}
    fullWidth={fullWidth}
    {...other}
  />
);

export default TextField;
